import React from "react";
import { useNavigate } from "react-router-dom";
import { useWallet } from "../../../hooks/useWallet";
import LnUrl from "./components/LnUrl";
import { QRCodeCanvas } from "qrcode.react";
import { LayoutWithTopBar } from "../../../components/LayoutWithTopBar";
import { useTheme } from "../../../hooks/useTheme";

interface ReceiveTransactionProps {
  
}

const ReceiveTransaction: React.FC<ReceiveTransactionProps> = () => {
    const { lnurl } = useWallet();
    const navigate = useNavigate();
    const {isMobile, isDarkMode} = useTheme();

    const onClickPrevArrow = () => {
        if(isMobile)
            return () => navigate(`/home/wallet`);

        return undefined;
    }

    return (
        <LayoutWithTopBar
            breadcrumbs={[
                { title: 'Wallet', onClick: () => navigate('/home/wallet') },
                { title: 'Receive' }
            ]}
            onClickPrevArrow={onClickPrevArrow()}
        >
            <div className="flex-1 px-4 flex justify-center items-center">
                <div className="bg-brand-bg-2 rounded-lg p-4 flex flex-col gap-4">
                    <div className="flex justify-center">
                        <div className="bg-brand-white rounded-lg p-4 flex justify-center items-center relative">
                            <QRCodeCanvas
                                value={lnurl}
                                size={220}
                                bgColor="#FFFFFF"
                                fgColor="#000000"
                                level="H"  // Error correction level: L, M, Q, H
                                style={{ 
                                    maxWidth: '100%',
                                    height: 'auto',
                                    backgroundColor: "#FFFFFF",
                                    filter: "none"
                                 }}
                            />
                            <img 
                                src="/images/logo192.png" // Adjust path to your logo
                                alt="Logo"
                                className="absolute w-[67px] h-[67px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  p-1"
                            />
                        </div>
                    </div>
                    
                    <LnUrl lnurl={lnurl} className="justify-center" />
                </div>
            </div>

            <div className="flex flex-col items-center p-4 mb-2">
                {
                    isDarkMode ?
                        <img src={"/images/opa_logo_text.png"} alt="" className="w-[190px]" />
                    :
                        <img src={"/images/opa_logo_text_light.png"} alt="" className="w-[190px]" />
                }
            </div>
        </LayoutWithTopBar>
    );
}

export default ReceiveTransaction;